import { useQuery } from 'react-query';
import { getSubscriptionStatus } from '../services/monday';
import { featureBasedPricingPlans } from '../constants/featureBasedPricing';
import queryKeys from '@/constants/queryKeys';

const useFeatureBasedPricing = () => {
  const { data: subscriptionData, isLoading: isLoadingSubscriptionData } =
    useQuery(queryKeys.MONDAY_GET_SUBSCRIPTION_STATUS, getSubscriptionStatus, {
      refetchOnWindowFocus: false,
    });

  const planId = subscriptionData?.data?.app_subscription?.[0]?.plan_id;
  const hasNoSubscription =
    subscriptionData?.data?.app_subscription.length === 0;

  const isFreeSubscription =
    [featureBasedPricingPlans.free, featureBasedPricingPlans.basic].includes(
      planId,
    ) || hasNoSubscription;

  const isFree = planId === featureBasedPricingPlans.free || hasNoSubscription;

  const isStarter = planId === featureBasedPricingPlans.starter;

  const isBasic = planId === featureBasedPricingPlans.basic;

  const isStandard = planId === featureBasedPricingPlans.standard;

  const isPro = planId === featureBasedPricingPlans.pro;

  const enterprisePlans = [
    featureBasedPricingPlans.enterprise,
    featureBasedPricingPlans.gs_enterprise_m,
    featureBasedPricingPlans.gs_enterprise_l,
    featureBasedPricingPlans.gs_enterprise_xl,
    featureBasedPricingPlans.gs_enterprise_xxl,
  ];
  const isEnterprise = enterprisePlans.includes(planId);

  const featuresInCurrentPlan = {
    isMultipleTemplatesNotAvailable: isFree || isStarter,
    isOtpNotAvailable: isFree || isStarter || isStandard || isBasic ,
    isSignatureInviteLinkNotAvailable: isFree || isStarter,
    isBrandingNotAvailable: isFree || isStarter || isBasic,
    isTemplateGalleryPermissionsNotAvailable: isFree || isStarter,
    isAutoSendNotAvailable: false,
    isAutoSendPremium: isFree || isStarter,
    isDigitalSignatureAvailable: isBasic || isStandard || isPro || isEnterprise,
    isFormFillerNotAvailable: isFree,
  };

  const isOldPricingPlan =
    subscriptionData?.data?.app_subscription?.[0]?.pricing_version < 4;

  return {
    isLoadingSubscriptionData,
    isFreeSubscription,
    isFree,
    isBasic,
    isStandard,
    isPro,
    isEnterprise,
    isOldPricingPlan,
    featuresInCurrentPlan,
  };
};

export default useFeatureBasedPricing;
